import { useRef, useState } from "react";
import { SquareLoader } from "screens/Main/components/Loader/SquareLoader";
import ImagePlaceholder from "assets/images/dapps/imagePlaceholder.png";
import { MIN_IMG_FILE_SIZE } from "screens/DApps/constants";
import { fileApi } from "services/files";
import { FormField } from "components/FormField";
import { isValidUrl } from "utils/string";
import TrashIcon from "assets/icons/TrashIcon";
import { ALLOWED_IMAGE_TYPES } from "types/files";

type TProps = {
  id?: string;
  banner?: string;
  link: string;
  onDelete: () => void;
  onEditBanner: (value: string) => void;
  onEditLink: (value: string) => void;
};

export const CryptoProjectCampaign = ({ link, banner, id, onEditBanner, onEditLink, onDelete }: TProps) => {
  const [isBannerLoading, setIsBannerLoading] = useState(false);
  const fileRef = useRef<HTMLInputElement>(null);

  const handleBannerFileChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    const allowedTypes = ALLOWED_IMAGE_TYPES.map((type) => 'image/' + type.replaceAll('.', ''));

    if (!file) return;

    if (file.size > MIN_IMG_FILE_SIZE || !allowedTypes.includes(file.type)) {
      alert(`Maximum file size is ${MIN_IMG_FILE_SIZE / 1000} KB, format: ${ALLOWED_IMAGE_TYPES.join(", ")}`);
      return;
    }

    try {
      setIsBannerLoading(true);
      const url = await fileApi.uploadImage(file);
      if (url) {
        onEditBanner(url);
      }
    } finally {
      setIsBannerLoading(false);
    }
  };

  const handleBannerClick = () => {
    if (fileRef.current) {
      fileRef.current.click();
    }
  };

  return (
    <li className="relative bg-[#202020] p-4 rounded-lg flex flex-col gap-2">
      <button
        className="absolute top-2 right-2 text-gray-400 hover:text-red-500"
        onClick={onDelete}
      >
        <TrashIcon />
      </button>

      <p>Banner:</p>

      <div
        className="w-[308px] h-[92px] object-cover rounded-[9px] bg-[#131313] flex items-center justify-center cursor-pointer"
        onClick={handleBannerClick}
      >
        {isBannerLoading ? <SquareLoader /> : (
          <img
            src={banner || ImagePlaceholder}
            alt="Banner"
            className="w-[308px] h-[92px] object-cover rounded-[9px] object-scale-down"
          />
        )}

        <input
          ref={fileRef}
          id="banner"
          type="file"
          accept={ALLOWED_IMAGE_TYPES.join(",")}
          style={{ display: "none" }}
          onChange={handleBannerFileChange}
        />
      </div>

      <FormField
        label="Link"
        value={link}
        onChange={(e) => onEditLink(e.target.value)}
        validate={{
          func: isValidUrl,
          message: "Invalid URL",
        }}
      />
    </li>
  );
};
